import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Img } from '@alfa-bank/site-img';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { ILoadingBlockProps } from './models';
import styles from './styles/styles.css';

export const LoadingBlockDesktop: FC<ILoadingBlockProps> = ({ loadingIconSrc, loadingText }) => {
    return (
        <Grid collapse columnsWidth={[24, 8, 'auto']} justify="center">
            <Img
                className={cn(styles.external, styles.img)}
                height={24}
                src={loadingIconSrc}
                width={24}
            />
            <></>
            <Text tag="span" view="primary-medium">
                {loadingText}
            </Text>
        </Grid>
    );
};
